import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "./App.css";

// Firebase Analytics is initialized in firebase.ts
// Import { analytics } from './firebase' when you need to track events

function Home() {
	const [isMobileDevice, setIsMobileDevice] = useState(false);

	useEffect(() => {
		const userAgent =
			navigator.userAgent || navigator.vendor || (window as any).opera;

		// Check for Android
		const isAndroid = /android/i.test(userAgent);

		// Check for iOS
		const isIOS =
			/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;

		setIsMobileDevice(isAndroid || isIOS);
	}, []);

	return (
		<div className="App">
			<header className="hero-section">
				<div className="hero-content">
					<div className="app-logo-container">
						<img
							src="/bhd1/adaptive-icon.png"
							alt="App Icon"
							className="app-emblem-img"
						/>
					</div>
					<h1 className="app-title">רב אלוף</h1>
					<p className="app-tagline">הדרך הקלה למקראות ישראל!</p>
					<p className="app-description">
						אפליקציה ללימוד מקראות ישראל - תרגול, משחקים, קריאה
						והאזנה
					</p>
					{isMobileDevice && (
						<Link to="/download" className="download-now-button">
							הורידו עכשיו
						</Link>
					)}
				</div>
			</header>

			<section className="features-section">
				<h2 className="section-title">מה באפליקציה?</h2>
				<div className="features-grid">
					<div className="feature-card">
						<div className="feature-icon">
							<img src="/home-icons/test.png" alt="Test" />
						</div>
						<h3>התנסו במבחן</h3>
						<p>תרגול עם מבחנים ושאלות רב-ברירתיות</p>
					</div>
					<div className="feature-card">
						<div className="feature-icon">
							<img src="/home-icons/game.png" alt="Game" />
						</div>
						<h3>שחקו ותרגלו</h3>
						<p>למידה דרך משחקים אינטראקטיביים</p>
					</div>
					<div className="feature-card">
						<div className="feature-icon">
							<img src="/home-icons/study.png" alt="Study" />
						</div>
						<h3>קראו ולימדו</h3>
						<p>חומרי לימוד מקיפים ומפורטים</p>
					</div>
					<div className="feature-card">
						<div className="feature-icon">
							<img src="/home-icons/earpods.png" alt="Listen" />
						</div>
						<h3>האזינו ולימדו</h3>
						<p>פודקאסטים ותכנים קוליים להאזנה</p>
					</div>
				</div>
			</section>

			<section className="screenshots-section">
				<h2 className="section-title">תמונות מהאפליקציה</h2>
				<div className="screenshots-grid">
					{[
						"shot_1_6.5_straight.webp",
						"shot_2_6.5_straight.webp",
						"shot_3_6.5_straight.webp",
						"shot_4_6.5_straight.webp",
						"shot_5_6.5_straight.webp",
						"shot_6_6.5_straight.webp",
						"shot_7_6.5_straight.webp",
						"shot_8_6.5_straight.webp",
					].map((screenshot, index) => (
						<div className="screenshot-item" key={screenshot}>
							<img
								src={`/screenshots/${screenshot}`}
								alt={`תמונה ${index + 1} מהאפליקציה`}
								className="screenshot-image"
								loading="lazy"
								onError={(e) => {
									(
										e.target as HTMLImageElement
									).style.display = "none";
								}}
							/>
						</div>
					))}
				</div>
			</section>

			<section className="download-section">
				<h2 className="section-title">הורידו עכשיו</h2>
				<div className="download-buttons">
					<a
						href="https://play.google.com/store/apps/details?id=com.zigliad.bhd1"
						target="_blank"
						rel="noopener noreferrer"
						className="download-button google-play"
					>
						<span className="download-icon">📱</span>
						<div className="download-text">
							<span className="download-label">הורדה מ-</span>
							<span className="download-store">Google Play</span>
						</div>
					</a>
					<a
						href="https://apps.apple.com/app/id6757281547?action=write-review"
						target="_blank"
						rel="noopener noreferrer"
						className="download-button app-store"
					>
						<span className="download-icon">🍎</span>
						<div className="download-text">
							<span className="download-label">הורדה מ-</span>
							<span className="download-store">App Store</span>
						</div>
					</a>
				</div>
			</section>

			<section className="about-section">
				<h2 className="section-title">קצת עליי</h2>
				<div className="about-content-wrapper">
					<div className="about-image-container">
						<img
							src="/me.jpg"
							alt="Liad Zigdon"
							className="about-image"
						/>
					</div>
					<div className="about-text-content">
						<p>
							אהלן! אני ליעד. קצין, מפתח, ובעיקר אחד שהיה בדיוק
							במקום שלכם. 👋
						</p>
						<Link to="/about" className="about-read-more-button">
							המשיכו לקרוא...
						</Link>
					</div>
				</div>
			</section>

			<footer className="footer">
				<div className="footer-content">
					<p className="footer-text">
						© 2026 רב אלוף. כל הזכויות שמורות.
					</p>
					<Link to="/privacy" className="footer-link">
						מדיניות פרטיות
					</Link>
					<Link to="/about" className="footer-link">
						קצת עליי
					</Link>
				</div>
			</footer>
		</div>
	);
}

export default Home;
